import { DownloadDocumentButton } from '@/components/DownloadDocumentButton/DownloadDocumentButton'
import './Core.css'
import { ErrorIcon } from '@/components/SignDocumentCore/ErrorIcon'

interface ErrorContainerProps {
  height?: string | number
  width?: string | number
  documentUrl?: string
  setAllowSigning?: (allow: boolean) => void
  failedToLoadPdf: string
}

export const PdfErrorContainer: React.FC<ErrorContainerProps> = ({
  width,
  height,
  documentUrl,
  failedToLoadPdf,
  setAllowSigning,
}) => {
  return (
    <div
      className="pdf-ocg-core__viewer-container"
      style={{
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
      }}
    >
      <div className="pdf-ocg-core__error-container">
        <ErrorIcon
          fillColor={'var(--icon-custom-color, var(--icon-main-color))'}
          backgroundColor="white"
        />

        <div className="pdf-ocg-core__error-title">{failedToLoadPdf}</div>

        {documentUrl && (
          <DownloadDocumentButton
            documentUrl={documentUrl}
            margin="0"
            onClick={() => setAllowSigning && setAllowSigning(true)}
            alwaysDisplayText={true}
          />
        )}
      </div>
    </div>
  )
}
